import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import {
  ApplicationConfigurationStoreActions,
  ApplicationConfigurationStoreStates,
} from '../application-configuration';

@Injectable()
export class ApplicationConfigurationResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly applicationConfigurationStore: Store<ApplicationConfigurationStoreStates.ApplicationConfigurationState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.applicationConfigurationStore.dispatch(
          ApplicationConfigurationStoreActions.ApplicationConfigurationResolverActions.configurationRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
